import { Controller } from "@hotwired/stimulus";

export default class InfractionFilterController extends Controller {
  static targets = ["row"];

  filter(e) {
    const val = e.target.value;
    this.rowTargets.forEach((r) => {
      r.classList.toggle("hidden", val !== "" && r.dataset.actionType !== val);
    });
  }
}
